const messages = {
  title: "Mein Konto",
  desc: "Willkommen in Ihrem persönlichen Bereich. Hier können Sie Ihre Stammdaten ergänzen oder <br/> anpassen, Ihr Postfach und Ihren Punkte-Kontosauszug einsehen.",
  descStaff:
    "Willkommen in Ihrem persönlichen Bereich. Hier können Sie Ihre Stammdaten ergänzen oder <br/> anpassen, Ihr Postfach und Ihren Punkte-Kontosauszug einsehen.",
  buttons: {
    showProfile: "Profil anzeigen",
    userProfile: "Zu ihren stammdaten",
    mailbox: "Zum postfach",
    addNewEmail: "Neue E-Mail-Adresse hinzufügen",
    favoriteProducts: "Zu Ihren Lieblingsprodukten",
  },
  categories: {
    baseData: {
      title: "Stammdaten",
      desc: "Vervollständigen Sie Ihre persönlichen und Unternehmensdaten für eine korrekte Registrierung.",
    },
    mailbox: {
      desc: "Wichtige Nachrichten, Bestellbestätigungen und Neuigkeiten finden Sie in Ihrem persönlichen Postfach.",
    },
    bankstatement: {
      title: "Kontoauszug",
      desc: "Hier können Sie Ihren aktuellen Prämienpunktestand und die Kontobewegungen einsehen.",
    },
    favoriteProducts: {
      title: "Lieblingsprodukte",
      desc: "Hier finden Sie die von Ihnen gespeicherten Produkte.",
    },
  },
  profile: {
    general: "PERSÖNLICHE DATEN UNTERNEHMENSDATEN",
    title: "Meine Stammdaten",
    description:
      "Willkommen in Ihrem persönlichen Bereich. Hier können Sie Ihre Stammdaten ergänzen oder anpassen, Ihr Postfach und Ihren Punkte-Kontosauszug einsehen.",
    block_description:
      "Willkommen in Ihrem persönlichen Bereich. Hier können Sie Ihre Daten einsehen",
    personalData: "Persönliche daten",
    password: "Passwort",
    password1: "Passwort (frei wählbar)*",
    password2: "Passwort (Wiederholung)*",
    formOfAddress: "Anrede",
    choose: "Bitte wählen",
    mr: "Herr",
    mrs: "Frau",
    diverse: "Diverse",
    firstname: "Vorname",
    surname: "Nachname",
    position: "Position im betrieb",
    operatingData: "Betriebsdaten",
    company: "Firma",
    legalForm: "MWST. NUMMER",
    name: "Name",
    streetHouseNr: "Strasse und Hausnr.",
    street: "Strasse",
    postcode: "PLZ",
    location: "ORT",
    country: "Land",
    de: "Deutschland",
    at: "Österreich",
    ch: "Schweiz",
    nl: "Niederlande",
    it: "Italien",
    language: "Sprache",
    french: "Französisch",
    italian: "Italienisch",
    german: "Deutschland",
    nederland: "Niederlande",
    phone: "Telefon",
    website: "Webseite",
    operatingIndicators: "Betriebskennzahlen",
    tireSale: "Reifenumsatz pro Jahr ca. in Stk.",
    tireSaleLabel: "Verkaufen Sie Reifen in grossen Mengen",
    inches: "Davon ≥ 18 Zoll (in %)",
    inchesLabel: "Davon 18 Zoll und grösser in %",
    segmentSale:
      "Reifenabsatz nach segmenten (Anteil Budget / Mid / Premium in %)",
    premBudget: "Premium",
    midBudget: "Mid",
    budBudget: "Budget",
    distribution: "VERTEILUNG SOMMER / WINTER / ALL SEASON (in %)",
    summerIn: "Hinein in den Sommer",
    winterIn: "Der Winter ist da",
    allSeasonIn: "Die ganze Saison über",
    tyreSizes: "Anzahl einlagerungen pro saison (Reifensätze)",
    diffDeliveryAddres: "Lieferadresse hinzufügen",
    yourEmailAddress: "Ihre E-Mail Adresse*",
    clientNr: "Kundennummern",
    clientNrSingular: "Kundennummer",
    clientNrContent:
      "<span class='text-danger fw-bold'>WICHTIG - BITTE LESEN:</span><br /><br /> Für die Zuordnung Ihrer Reifenbestellungen beim Grosshandel und / oder bei Bridgestone ist es <b>zwingend erforderlich, dass Sie Ihre jeweiligen Kundenummern angeben.</b><br/><br/>Sollten Sie <b>mehrere Kundennummern bei einem Grosshändler und / oder bei Bridgestone haben,</b> z. B. für Ihr Hauptgeschäft und Ihre Filialen, geben Sie zuerst die Kundennummer des Hauptgeschäftes an.<br/><br/><b>Die Umsätze der weiteren Kundennummern werden dann Ihrem Hauptgeschäft zugeordnet.</b>",
    supplySource: "Bezugsquelle",
    email: "E-Mail Adresse",
    staffEmail: "Teilnehmer E-Mail adresse",
    registered: "Registriert am",
    registeredAt: "Registriert am",
    lastLogIn: "Letzer Log-in",
    details: "Details",
    inDetail: "{name} im Detail",
    customerFile: "Kundenakte",
    customerHistory: "Kundenhistorie",
    currentYear: "Laufendes Jahr",
    bsClientNr: "Ihre Bridgestone Kundennummer",
    bftClientNr: "Ihre Best4Tires Kundennummer",
    acceptTerms: "AGB und Teilnahmebedingungen aktzeptieren.",
    newCustomerNumbersInfo:
      "<span class='text-danger fw-bold'>WICHTIG - BITTE LESEN:</span><br />Bei erstmaliger Angabe der Kundennummer werden Ihre Angaben auf deren Richtigkeit und hinsichtlich unserer vertrieblichen Kriterien überprüft. Die Entscheidung über eine Freischaltung der Kundennummer(n) und Verknüpfung mit Ihrem Profil kann bis zu 5 Arbeitstage in Anspruchnehmen.",
    selectWholeSaler: "bei Lieferant (bitte eintragen)",
    cooperation: "MITGLIED / KOOPERATION",
    error100: "Die Summe der Werte muss 100% betragen.",
    errorRange: "Der Wert muss zwischen 0 und 100 liegen",
    btw_number_label: "Umsatzsteuer-Identifikationsnummer Ihres Unternehmens",
    btw_number: "Umsatzsteuer-Identifikationsnummer",
    mobile: "HANDYNUMMER",
    mobile_label: "Ihre (Mobil-)Telefonnummer",
    iban_number: "IBAN-Nummer IHRES UNTERNEHMENS",
    iban_number_label: "IBAN-nummer",
    yourCsNr: "Ihre Kundennummern",
    yourLastName: "Ihr Nachname",
    positionLabel: "Position auswählen",
    yourFirstName: "Ihr Vorname",
    companyLabel: "Firma",
    numberOfSetsOfSeasonalTiresBudget: "Einlagerungen pro Jahr",
    contactInfo: "Bei Rückfragen wenden Sie sich bitte an: {email}",
    addAnotherCsNumber: "Fügen Sie eine weitere Bridgestone-Kundennummer hinzu",
    activityAndProfile: "GESCHÄFTSBEZIEHUNG UND PROFIL",
    financialEmail: "Financial emails",
    indirectCustomNumberHelpMessage:
      "Wir konnten deine Kundennummer-Einstellung nicht erkennen. Bitte überprüfe dein Profil und bestätige, ob du ein direkter oder indirekter Kunde bist, um fortzufahren.",
    breakTimes: "Pausenzeiten",
    restDay: "Ruhetag",
    pause: "PAUSE",
    completeProfile: "Persönliches Profil vervollständigen und zusätzlich",
    completeProfileBold: "200 Punkte sichern.",
    fullCompleteProfile: "Ihr persönliches Profil ist vollständig! ",
  },
  countries: {
    al: "Albanien",
    ad: "Andorra",
    at: "Österreich",
    be: "Belgien",
    by: "Belarus",
    ba: "Bosnien und Herzegowina",
    bg: "Bulgarien",
    hr: "Kroatien",
    cy: "Zypern",
    cz: "Tschechien",
    dk: "Dänemark",
    ee: "Estland",
    fi: "Finnland",
    fr: "Frankreich",
    ge: "Georgien",
    gr: "Griechenland",
    es: "Spanien",
    nl: "Niederlande",
    ie: "Irland",
    is: "Island",
    kz: "Kasachstan",
    xk: "Kosovo",
    li: "Liechtenstein",
    lt: "Litauen",
    lu: "Luxemburg",
    lv: "Lettland",
    mk: "Nordmazedonien",
    mt: "Malta",
    md: "Moldau",
    mc: "Monaco",
    de: "Deutschland",
    no: "Norwegen",
    pl: "Polen",
    pt: "Portugal",
    ru: "Russland",
    ro: "Rumänien",
    sm: "San Marino",
    rs: "Serbien",
    sk: "Slowakei",
    si: "Slowenien",
    se: "Schweden",
    ch: "Schweiz",
    tr: "Türkei",
    ua: "Ukraine",
    hu: "Ungarn",
    gb: "Vereinigtes Königreich",
    it: "Italien",
    va: "Vatikanstadt",
  },
  addCsNumber: {
    title: "Notice",
    body: "Sind Sie sicher, dass Sie diese Kundennummer speichern möchten? Durch die Aktion werden Bearbeitungsdaten blockiert, bis der Administrator sie genehmigt.",
  },
  extraEmailSection: {
    description:
      "Extra email addresses are exclusively used for sending BS+ marketing information and/or financial information and should <b>under no circumstances be used for logging in or managing</b> the Bridgestone PLUS account.",
    optionOne: "For financial info (e.g., bonus specification)",
    optionTwo:
      "For Bridgestone Plus marketing communication (e.g., promotions/newsletters)",
    addNewEmail: "Add new email address",
  },
};

export default {
  messages,
};
